(function () {
	'use strict';

	angular
	.module('core')
	.directive('infoHover', infoHover);

	infoHover.$inject = ['$sce', '$timeout'];

	function infoHover($sce, $timeout) {
		return {
			restrict: 'E',
			replace: true,
			templateUrl: './templates/directives/info-hover.html',
			scope:{
				'text':'=?',
				'details':'=?'
			},
			link: function($scope, elem) {
				
			}
		}
	}
})();